const AboutAlldoer = ({ metrics = [], loading = false }) => {
  // Data for the timeline steps to keep the JSX clean and scalable
  const steps = [
    {
      title: "You Share Requirements",
      description:
        'Let us know your needs—like "1000 T-shirts" or "Diwali Decor for USA".',
    },
    {
      title: "Global Sourcing",
      description:
        "We identify the best manufacturing partners within our network to match your specs and budget.",
    },
    {
      title: "QC & Delivery",
      description:
        "We handle the quality check, packaging, and logistics to ship directly to your location.",
    },
  ];

  return (
    <section className="w-full bg-white py-16 px-6 md:px-12 lg:py-24">
      <div className="max-w-[1440px] mx-auto">
        {/* --- Top Section: What is Alldoer --- */}
        <div className="flex flex-col lg:flex-row justify-between items-start gap-8 lg:gap-16 mb-16">
          {/* Left Side Header */}
          <div className="lg:w-1/2">
            <h2 className="text-3xl md:text-4xl font-normal text-gray-900 mb-2">
              What is Alldoer
            </h2>
            <p className="text-lg md:text-xl text-gray-500 font-medium">
              Your sourcing partner and growth in success
            </p>
          </div>

          {/* Right Side Description */}
          <div className="lg:w-1/2">
            <p className="text-gray-500 leading-relaxed text-base md:text-lg font-medium">
              Alldoer isn't just a manufacturer—we are your custom sourcing
              agency. From corporate uniforms to festive decor, we execute your
              specific requirements and deliver worldwide.
            </p>
          </div>
        </div>

        {/* --- Divider Line --- */}
        <hr className="border-gray-200 mb-16" />

        {/* --- Bottom Section: How it Works --- */}
        <div>
          <h2 className="text-4xl md:text-5xl mb-12 font-normal">
            <span className="font-medium text-gray-900">How it </span>
            <span className="font-normal text-[#737373]">works</span>
          </h2>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            {/* Left Column: Image Collage */}
            <div className="grid grid-cols-2 gap-4">
              {/* First sub-column with stacked images */}
              <div className="flex flex-col gap-4 min-h-[24rem] md:min-h-[519px]">
                <div className="relative w-full h-full overflow-hidden rounded-2xl bg-gray-100">
                  <img
                    src={"./images/boxes-big.png"}
                    alt="Shipping Containers"
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="relative w-full h-full overflow-hidden rounded-2xl bg-gray-100">
                  <img
                    src={"./images/sale-person.png"}
                    alt="Delivery Handover"
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                  />
                </div>
              </div>

              {/* Second sub-column with tall image */}
              <div className="relative w-full h-full min-h-[24rem] md:min-h-[519px] overflow-hidden rounded-2xl bg-gray-100">
                <img
                  src={"./images/paper-girl.png"}
                  alt="Worker Packing Box"
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>
            </div>

            {/* Right Column: Timeline Steps */}
            <div className="relative pl-2">
              {/* Positioned slightly left to align with circle centers */}
              <div className="absolute left-[17px] top-3 bottom-12 w-[1px] bg-gray-200"></div>

              <div className="lg:space-y-32 space-y-12">
                {steps.map((step, index) => (
                  <div key={index} className="relative flex items-start gap-8 group cursor-default">
                    {/* The Circle Marker */}
                    <div className="relative z-10 flex-shrink-0 mt-1.5">
                      <div className="w-5 h-5 rounded-full border-2 border-red-500 bg-white shadow-sm ring-4 ring-white transition-transform duration-300 group-hover:scale-125"></div>
                    </div>

                    {/* Text Content */}
                    <div className="flex flex-col">
                      <h3 className="text-xl md:text-3xl font-normal text-gray-900 mb-2">
                        {step.title}
                      </h3>
                      <p className="text-gray-500 text-sm md:text-base leading-relaxed max-w-md font-medium">
                        {step.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutAlldoer;
